import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import ImportWizardEtablissement from '../components/ImportEtablissement/ImportWizardEtablissement';
import ComptesEnAttenteGar from '../components/ImportEtablissement/ComptesEnAttenteGar';
import Loading from '../components/general/Loading';

/**
 * Page du wizard d'import établissement — la SEULE porte de création/mise à
 * jour des élèves (spec §0.7). Réservée au délégué d'affectation et au chef
 * (le back re-vérifie : 403 sinon).
 */
function ImportEtablissement() {
    const { etablissementData, user } = useUser();

    if (!etablissementData || !user) {
        return <Loading loadingText={'Chargement...'} />;
    }

    const professeur = etablissementData?.professeurs?.find((p) => p.id === user?.id);
    const estDelegue = !!professeur?.delegue_affectation;
    const estChef = user?.role === 'chef';

    if (!estDelegue && !estChef) {
        return <Navigate to="/home/" replace />;
    }

    return (
        <div className="w-full px-3 sm:px-6 pt-4">
            {/* Compteur en-attente + fraîcheur — refetch quand l'étab est rafraîchi (post-apply) */}
            <ComptesEnAttenteGar refresh={etablissementData} />
            <ImportWizardEtablissement />
        </div>
    );
}

export default ImportEtablissement;
